<template>
  <div class="diagram  row-center">
    <div class="box">
      <div class="title">
        <span>近7日充电度数</span>
      </div>
      <div class="cont">
        <Charts id="chartOption2" :option="chartOption1" v-if="!chartShow"></Charts>
        <div v-else class="row-center not_found_data">
          <img src="../../../assets/img/not_found_data.png" alt="">
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title row-center">
        <span>近7日充电金额</span>
      </div>
      <div class="cont">
        <Charts id="chartOption1" :option="chartOption2" v-if="!chartShow"></Charts>
      </div>
    </div>
  </div>
</template>
<script>
import Charts from "../../../components/common/Charts.vue";
import {dayStart, dayEnd} from "../../../util/DateUtil";
import {inverterTotalLine, photovoltaicReport} from '../../../api/power'
import dayjs from "dayjs";

export default {
  data() {
    return {
      temp: [],
      SevenPower: [],
      GenerateList: {
        timeArr: [],
        valArr: []
      },
      chartShow: false,
      barWidth: 15
    };
  },
  components: {
    Charts
  },

  computed: {
    chartOption1() {
      return {
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },
        title: {
          text: '(kWh)',
          left: -5,// 距离左边位置
          top: -5,// 距离上面位置
          textStyle: {
            color: '#666',
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        tooltip: {
          trigger: 'none',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            dayjs().date() - 0 + '日',
            dayjs().date() - 6 + '日',
            dayjs().date() - 5 + '日',
            dayjs().date() - 4 + '日',
            dayjs().date() - 3 + '日',
            dayjs().date() - 2 + '日',
            dayjs().date() - 1 + '日'
          ]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#d5e2fc'
            },
          }
        ]
      }
    },
    chartOption2() {
      return {
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },
        title: {
          text: '(元)',
          left: -5,// 距离左边位置
          top: -5,// 距离上面位置
          textStyle: {
            color: '#666',
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        tooltip: {
          trigger: 'none',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            dayjs().date() - 0 + '日',
            dayjs().date() - 6 + '日',
            dayjs().date() - 5 + '日',
            dayjs().date() - 4 + '日',
            dayjs().date() - 3 + '日',
            dayjs().date() - 2 + '日',
            dayjs().date() - 1 + '日'
          ]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820 * 1.23, 932 * 1.32, 901 * 1.34, 934 * 1.25, 1290 * 1.23, 1330 * 1.25, 1320 * 1.23],
            type: 'line',
            smooth: true,
            areaStyle: {
              color: '#c9e6e5'
            },
          }
        ]
      }
    },
  },
};
</script>
<style lang="less" scoped>
.diagram {
  height: 100%;
  justify-content: space-between;
  flex-wrap: nowrap;

  .box {
    background: #ffffff;
    .w(592);
    height: 100%;
    padding: 18rem;
  }

  .title {
    font-size: 16rem;
    font-weight: bold;
    margin-bottom: 10rem;
    justify-content: space-between;

    .tag {
      label {
        color: #333;
        cursor: pointer;
        margin-left: 12px;
        position: relative;
      }

      .active {
        color: #0E9CFF;
      }

      .active::before {
        content: "";
        border-top: 2px solid #0E9CFF;
        position: absolute;
        top: -22rem;
        width: 100%;
      }
    }
  }

  .el-dropdown {
    color: #333;
    float: right;
    font-weight: 400;
  }

  .cont {
    justify-content: space-between;
    .h(250);
    width: 100%;

  }
}
</style>